export default __webpack_public_path__ + "static/media/596.06fbe780.png";